import FRFriendListLoaderContainer from './fr-friend-list-loader';

export default FRFriendListLoaderContainer;
